import styled from 'styled-components'

export const StyledClientsTable = styled.div`
  position: relative;
  width: 100%;
`
